import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { TalentPage } from './pages/TalentPage';
import { BrandsPage } from './pages/BrandsPage';
export function App() {
  useEffect(() => {
    document.title = 'HorizonIMA';
  }, []);
  return <Router data-id="element-0">
      <Routes data-id="element-1">
        <Route path="/" element={<HomePage data-id="element-3" />} data-id="element-2" />
        <Route path="/talent" element={<TalentPage data-id="element-5" />} data-id="element-4" />
        <Route path="/brands" element={<BrandsPage data-id="element-7" />} data-id="element-6" />
      </Routes>
    </Router>;
}